var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"area-text"},[_vm._v(_vm._s(this.row.customer.areaType ||'--'))]),_c('div',{staticClass:"ship-text"},[_vm._v(_vm._s(_vm.getShipName))])])}
var staticRenderFns = []

export { render, staticRenderFns }